import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ConnectionStatusService } from '../services/connection-status.service';
import { global } from '../global';

@Injectable()
export class ConnectionStatusInterceptor implements HttpInterceptor {
  constructor(private connectionStatusService: ConnectionStatusService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const targetsBackend = req.url.startsWith(global.url);
    return next.handle(req).pipe(
      tap(() => {
        if (targetsBackend) this.connectionStatusService.reportSuccess();
      }),
      catchError((error: HttpErrorResponse) => {
        if (targetsBackend && (error.status === 0 || [502, 503, 504].includes(error.status))) {
          this.connectionStatusService.reportFailure();
        }
        return throwError(() => error);
      })
    );
  }
}
